import Rules from "@/utils/Rules";
import Utils from "@/scripts/Utils";
import NewEnvelopeModal from "@/components/Signatures/NewFlow/NewEnvelopeModal.vue";
import {showErrorSnackBar, showSuccessSnackBar} from "@/utils/SnackBartHelper";
import EnvelopeService from "@/services/server/EnvelopeService";
import {showDeleteDialogAlert} from "@/utils/DialogAlertHelper";

export default {
    name: 'Signatures',
    components: {
        NewEnvelopeModal
    },
    data: () => ({
        envelopeDialog: false,
        isLoadingEnvelopes: false,
        loadingEnvelopeDialog: false,
        envelopes: [],
        searchText: null,
        mapperStatus: {
            draft: 'Rascunho',
            canceled: 'Cancelado',
            running: 'Em Progresso',
            closed: 'Finalizado'
        },
        headers: [
            {text: "Nome do Envelope", value: "attributes.name", sortable: true},
            {text: "Status", value: "attributes.status", sortable: true},
            {text: "Criado em", value: "attributes.created", sortable: true},
            {text: "Ultima Movimentação", value: "attributes.modified", sortable: true},
            {text: "Prazo Final", value: "attributes.deadline_at", sortable: true},
            {text: "Ações", value: "actions", sortable: false},
        ],
    }),
    computed: {
        ruleRequired() {
            return Rules.required();
        },
        searchedEnvelopes() {
            if (!this.envelopes || !this.searchText) {
                return this.envelopes || [];
            }

            return this.envelopes.filter(envelope =>
                envelope.attributes && envelope.attributes.name && 
                envelope.attributes.name.toLowerCase().includes(this.searchText.toLowerCase())
            );
        },
    },
    watch: {},
    methods: {
        formattedDate(date) {
            if (date === undefined) return

            return Utils.formatDateDayJs(new Date(date), 'DD/MM/YYYY [às] HH:mm');
        },
        async openEnvelope(item) {
            try {
                this.loadingEnvelopeDialog = true;

                const result = await EnvelopeService.getEnvelopeByIdFirebase(item.id)
                if (result.data.data.id_doc) await this.$router.push(`/signatures/${result.data.data.id_doc}`)

                this.loadingEnvelopeDialog = false;
            } catch (e) {
                this.loadingEnvelopeDialog = false;
                console.error(e);
            } finally {
                this.loadingEnvelopeDialog = false;
            }
        },
        openEnvelopeDialog() {
            this.envelopeDialog = true;
        },
        closeEnvelopeDialog() {
            this.envelopeDialog = false;
        },
        async getAllEnvelopes() {
            try {
                this.isLoadingEnvelopes = true;
                const result = await EnvelopeService.getEnvelopes();
                this.envelopes = result.data.data;
            } catch (error) {
                console.error(error);
                showErrorSnackBar("Aconteceu um erro inesperado, Contacte o Suporte!")
            } finally {
                this.isLoadingEnvelopes = false;
                this.closeEnvelopeDialog();
            }
        },
        async deleteEnvelope(id) {
            try {
                await EnvelopeService.deleteEnvelopeByIdClickSign(id);
                this.envelopes = this.envelopes.filter(envelope => envelope.id !== id);

                showSuccessSnackBar("Envelope deletado com sucesso!")
            } catch (error) {
                console.error(error);
                showErrorSnackBar("Aconteceu um erro inesperado, Contacte o Suporte!")
            }
        },
        async confirmDeleteEnvelope(id) {
            showDeleteDialogAlert('Tem certeza que deseja deletar esse envelope? essa ação não pode ser desfeita', () => this.deleteEnvelope(id))
        }
    },
    async created() {
        await this.getAllEnvelopes();
    }
}